const popUppp = document.querySelector('.buy_more_save_more');
function buyMore() {
  if(popUppp){
    popUppp.classList.toggle('active');
  }
  }
  function hideBuyMore() {
    if(popUppp){
       popUppp.classList.remove('active');
    }
  }
document.querySelectorAll(".buy_more_save_more .Qty__buttons").forEach(button =>{
  button.addEventListener("click",(e)=>{
    e.stopPropagation();
    document.querySelector('.buy_more_save_more').classList.remove('active');
  })
})
  document.addEventListener("click", function (e) {
    const popup = document.querySelector('.buy_more_save_more');
    const opener = document.querySelector('.pop_up_opener_buy_more_save_more');
    if(popup && opener){
    if (!popup.contains(e.target) && !opener.contains(e.target)) {
      hideBuyMore();
    }
    }
  });

// Format and update price function
function updatePrices(activeElement) {
  const shopify = Shopify;
  const currency = shopify.currency.active;

  const tempSymbol = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    currencyDisplay: 'symbol'
  }).formatToParts(0).find(part => part.type === 'currency').value;

  function formatPrice(cents) {
    const amountOnly = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100);

    return `${tempSymbol}${amountOnly} ${currency}`;
  }

  const compare_price = parseFloat(activeElement.dataset.compare_price);
  const original_price = parseFloat(activeElement.dataset.price);

  const formattedComparePrice = formatPrice(compare_price);
  const formattedOriginalPrice = formatPrice(original_price);

  document.querySelector('#custom_compare_price').textContent = formattedComparePrice;
  document.querySelector('.custom_price--price .price-item--sale').textContent = formattedOriginalPrice;
}

const imageCache = {};

function preloadAndSetImage(imageEl, src) {
  if (imageCache[src]) {
    imageEl.src = src;
    imageEl.classList.remove("loading")
    return;
  }
  imageEl.classList.add("loading");
  const img = new Image();
  img.onload = () => {
    imageCache[src] = true;
    imageEl.src = src;
    imageEl.classList.remove("loading")
  };
  img.src = src;
}

document.addEventListener("DOMContentLoaded", () => {
  const bundlePAck = document.querySelectorAll(".Qty__buttons");
  const qtyToCart = document.querySelector("#added_to_cart_qty");
  const selectedItemContainer = document.querySelector(".selected_item");
  const productColors = document.querySelectorAll('.variant_featured_image_bundle');
  let activeVariantOpt = document.querySelectorAll('.product_option_values');
  let selectedActiveVar = [];
  let matchedVariant;
  let finalCartImage;
  let replaceIndex = 0;
  let allPlaceholders = [];
 
  function activeVariants() {
    const variantArray = Array.from(activeVariantOpt);
    selectedActiveVar = variantArray.filter(active => active.classList.contains('active'));
    variantUpdate();
  }

  activeVariants();

  function variantUpdate() {
    const selectedOptionValues = selectedActiveVar.map(option =>
      option.textContent.trim()
    );
    matchedVariant = window.featureProduct.variants.find(variant => {
      return selectedOptionValues.every((val, idx) => val === variant.options[idx]);
    });
    document.querySelector("#add_to_cart_popup_button").setAttribute('data-matched_var', matchedVariant.id);
    AddtocartButtonUpdate();
  }

  function openVariantPopup() {
    document.querySelector(".variant_popup_custom").classList.add('active');
    document.body.classList.add("overflow-hidden")
  }

  document.querySelector(".variant_popup_custom .icon-close-small").addEventListener('click', () => {
    document.querySelector(".variant_popup_custom").classList.remove('active');
    document.body.classList.remove("overflow-hidden")
  });

  document.addEventListener('click', function (event) {
    const popup = document.querySelector('.variant_popup_custom');
    const isClickInsidePopup = popup.contains(event.target);
    const isPopupOpen = popup.classList.contains('active');

    if (!isClickInsidePopup && isPopupOpen && !event.target.classList.contains('variant_featured_image_bundle')) {
      popup.classList.remove('active');
      document.body.classList.remove("overflow-hidden")
    }
  });

  document.querySelectorAll('.dpl_flex_popup').forEach(el => {
    const option = el.querySelectorAll(".product_option_values");
    option.forEach(opt => {
      opt.addEventListener("click", () => {
        const mainImageSrc = opt.dataset.image;
        option.forEach(item => item.classList.remove('active'));
        opt.classList.add("active");

        const popupImg = document.querySelector(".variant_popup_custom img");
        // preloadAndSetImage(popupImg, mainImageSrc);

        activeVariants();
        AddtocartButtonUpdate();
      });
    });
  });

  function renderPlaceholders(qty) {
    selectedItemContainer.innerHTML = "";
    allPlaceholders = [];
    replaceIndex = 0;

    for (let i = 0; i < qty; i++) {
      const createdEl = document.createElement("div");
      createdEl.classList.add("fake_item_shape");
      createdEl.setAttribute("data-number", i + 1);
      createdEl.innerHTML = `
        <index>${i + 1}</index>
        <p class="remove-btn">Remove</p>`;
      selectedItemContainer.appendChild(createdEl);
      allPlaceholders.push(createdEl);
    }

    enableRemoveFunction();
  }

  function enableRemoveFunction() {
    document.querySelectorAll(".fake_item_shape .remove-btn").forEach(removeBtn => {
      removeBtn.addEventListener("click", function (e) {
        const parent = e.target.closest(".fake_item_shape");
        let number = parent.dataset.number;
        parent.innerHTML = `
          <index>${number}</index>
          <p class="remove-btn">Remove</p>`;
        enableRemoveFunction();
      });
    });
  }

  function AddtocartButtonUpdate() {
    const addBtn = document.querySelector("#add_to_cart_popup_button");

    if (!matchedVariant) return;

    if (!matchedVariant.available) {
      addBtn.classList.add("disabled");
      addBtn.innerText = addBtn.getAttribute("btn-text_sold");
      addBtn.setAttribute("disabled", "disabled");
    } else {
      addBtn.classList.remove("disabled");
      addBtn.innerText = addBtn.getAttribute("btn-text");
      addBtn.removeAttribute("disabled");
      addBtn.setAttribute("data-matched_var", matchedVariant.id);
    }
  }

  const activePack = document.querySelector(".Qty__buttons.active");
  if (activePack) {
    const initialQty = parseInt(activePack.dataset.qty);
    qtyToCart.value = initialQty;
    renderPlaceholders(initialQty);
    updatePrices(activePack);
  }

  bundlePAck.forEach(pack => {
    pack.addEventListener("click", () => {
      bundlePAck.forEach(p => p.classList.remove("active"));
      pack.classList.add("active");

      const dataQty = parseInt(pack.dataset.qty);
      qtyToCart.value = dataQty;
      renderPlaceholders(dataQty);
      hideBuyMore();
      updatePrices(pack);
    });
  });

  productColors.forEach(variantImage => {
    variantImage.addEventListener("click", () => {
      const clickedVarId = variantImage.dataset.varId;
      document.querySelectorAll("img.popup_image.hidden").forEach(img =>{
      // document.querySelectorAll("img.popup_image.hidden").forEach(im => im.classList.remove("active"));
        if(img.dataset.id == clickedVarId){
          img.classList.add("active")
        }
        else{
          img.classList.remove("active")
        }
      })
      document.querySelector(".variant_popup_custom img").src = variantImage.dataset.image;
      const popupOptions = document.querySelectorAll(".variant_popup_custom .product_option_values[data-name='color']");
      popupOptions.forEach(opt => {
        const optionVarId = opt.dataset.varId;
        if (optionVarId === clickedVarId) {
          popupOptions.forEach(o => o.classList.remove("active"));
          opt.classList.add("active");
          activeVariants();
          hideBuyMore();
        }
      });

      const popupOptions2 = document.querySelectorAll(".variant_popup_custom .product_option_values[data-name='travel-neck-pillow-color']");
      popupOptions2.forEach(opt => {
        const optionVarId2 = opt.dataset.varId;
        if (optionVarId2 === clickedVarId) {
          popupOptions2.forEach(o => o.classList.remove("active"));
          opt.classList.add("active");
          activeVariants();
          hideBuyMore()
        }
      });

      openVariantPopup();
      AddtocartButtonUpdate();
    });
  });

  document.querySelector("#add_to_cart_popup_button").addEventListener("click", function () {
    for (let i = 0; i < allPlaceholders.length; i++) {
      const placeholder = allPlaceholders[i];
      const hasImg = placeholder.querySelector("img");

      if (!hasImg || placeholder.querySelector("svg")) {
        const imageSrc = document.querySelector(".variant_popup_custom img.active").src;
        finalCartImage = document.createElement("img");
        finalCartImage.src = imageSrc;
        finalCartImage.setAttribute('data-product_var', matchedVariant.id);
        finalCartImage.alt = "Selected Variant";
        finalCartImage.classList.add("selected_variant_image");

        const existingSvg = placeholder.querySelector("index");
        if (existingSvg) {
          existingSvg.remove();
        }

        const removeText = placeholder.querySelector("p");
        placeholder.insertBefore(finalCartImage, removeText);
        break;
      }
    }

    document.querySelector(".variant_popup_custom").classList.remove('active');
    document.body.classList.remove("overflow-hidden")
    updateSelectedVariants();
  });
});
document.addEventListener("click",(e)=>{
const main_product_image = document.querySelector(".product__media-item.is-active img")
  if(e.target.classList.contains("main__image_changer")){
    const imgSRC = e.target.dataset.main_image;
    if(imgSRC){
    main_product_image.src = imgSRC
    main_product_image.srcset = imgSRC
    }
  }
})